<!-- src/shared/components/logos/DefaultLogo.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
    import MonotoneJapaneseSecretButton from '@/shared/components/icons/MonotoneJapaneseSecretButtonIcon.vue';
  import { useBootstrapStore } from '@/shared/stores/bootstrapStore';
  import { NEUTRAL_BRAND_DEFAULTS } from '@/shared/constants/brand';
  import { type LogoConfig } from '@/types/ui/layouts';
  import { computed } from 'vue';

  /**
   * Props for controlling logo appearance
   */
  const props = withDefaults(
    defineProps<LogoConfig & { isColonelArea?: boolean }>(),
    {
      size: 64,
      href: '/',
      isColonelArea: false,
    }
  );

  const { t } = useI18n();
  const bootstrapStore = useBootstrapStore();

  /**
   * Brand-aware aria-label. Falls back to NEUTRAL_BRAND_DEFAULTS.product_name
   * (a generic "My App") when bootstrap config has not provided a brand name.
   * Never defaults to OTS branding — keeps private-label deployments neutral
   * (#3048 / #3049).
   */
  const ariaLabel = computed(
    () => props.ariaLabel || bootstrapStore.brand_product_name || NEUTRAL_BRAND_DEFAULTS.product_name
  );

</script>

<template>
  <div
    class="flex items-center gap-3"
    :aria-label="ariaLabel">
    <a
      :href="props.href"
      class="flex items-center gap-3">
      <!-- Logo Mark -->
      <img :src="logoLight"
:alt="ariaLabel"
class="dark:hidden h-8" />
      <img :src="logoDark"
:alt="ariaLabel"
class="hidden dark:block h-8" />

    </a>
  </div>
</template>
